import { Injectable, NgZone } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  NavigationEnd,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { NavController } from '@ionic/angular';

import { AOAuthService } from '../services/ao-auth.service';
import { AOSubscriptions } from '../utils/ao-subscriptions';

@Injectable()
export class AOUserGuard implements CanActivate, CanActivateChild {

  private _subscriptions: AOSubscriptions = new AOSubscriptions();

  constructor(
    private _router: Router,
    private _nav: NavController,
    private _zone: NgZone,
    private _auth: AOAuthService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.can(route, state);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.can(childRoute, state);
  }

  can(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (this._auth.isGuest()) {
      this._auth.setRedirect(state.url);
      return this._router.createUrlTree(['/login']);
    }

    this._subscriptions.add('logout', AOAuthService._onLogout.subscribe(() => {
      this._subscriptions.stop();
      this._zone.run(() => {
        this._nav.navigateRoot('/login');
      });
    }));

    this._subscriptions.add('route', this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url !== state.url) {
        this._subscriptions.stop();
      }
    }));

    return true;
  }

}
